module.exports = __webpack_public_path__ + "static/img/page.9179fce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page.jpg
// module id = qeXW
// module chunks = 0